import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IMissionPlan } from './missionPlan/IMissionPlan'


export class IrisrawModMissionPlan extends IrisModContainer<IMissionPlan> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModMissionPlan.createIrisrawMissionPlan)        
    }

    static createIrisrawModMissionPlan(datas:IIrisModContainerConstParam) {        
        return new IrisrawModMissionPlan(datas)
    }

    static createIrisrawMissionPlan(data:IMissionPlan) {        
        return data as IMissionPlan
    }

}